export const getCallMobileState = (state) => state.callMobile;
